<template>
  <div class="container">
    <div class="tw-grid tw-grid-cols-4 tw-gap-8">
      <DashboardNavigation :user="user"/>

      <div class="tw-col-span-3">
        <TheFilterForm :from.sync="from" :to.sync="to" :breakdown.sync="breakdown"/>

        <hr class="tw-mx-0 tw-my-8">

        <TheOverviewPanel :user="user" :from="from" :to="to" :breakdown="breakdown"/>

        <TheValueChartPanel :user="user" :from="from" :to="to" :breakdown="breakdown"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DashboardNavigation from '../DashboardNavigation'
import TheValueChartPanel from './TheValueChartPanel'
import TheOverviewPanel from './TheOverviewPanel'
import TheFilterForm from './TheFilterForm'

export default {
  components: {TheFilterForm, TheOverviewPanel, TheValueChartPanel, DashboardNavigation},

  model: {
    prop: 'user'
  },

  props: {
    user: {
      required: true
    }
  },

  data() {
    return {
      from: moment().startOf('year').format('YYYY-MM-DD'),
      to: moment().endOf('year').format('YYYY-MM-DD'),
      breakdown: 'months'
    }
  }
}
</script>
